import React from 'react'
import { useLocation } from 'react-router-dom'
import styles from './styles.module.scss'

// 10 steps need to display progress bar
// Removed party count and table count page
const STEPS = [
  '/color-palette',
  '/flower-selection',
  '/email-entry',
  '/partner-full-name',
  '/date-picker',
  '/guests',
  '/expected-budget',
  // '/party-count',
  // '/table-count',
  '/floral-planning',
]

const ProgressBar: React.FC = () => {
  const location = useLocation()
  // Find index of current step in steps
  const currentIndex = STEPS.findIndex((step) => location.pathname === step)
  // If not in steps, don't render
  if (currentIndex === -1) return null
  // Calculate percentage progress
  const percent = ((currentIndex + 1) / STEPS.length) * 100

  return (
    <div className={styles.progressBarContainer}>
      <div className={styles.progressBarBackground}>
        <div className={styles.progressBarFill} style={{ width: `${percent}%` }} />
      </div>
    </div>
  )
}

export default ProgressBar
